/**
 * Fusion intelligente des données attendance
 * Gère la déduplication et le tri pour éviter doublons et ordre aléatoire
 */

/**
 * Fusionne l'existant et le nouvel arrivage attendance
 * - Dédup par id
 * - Merge superficiel par id (les champs du newRow écrasent l'existant)
 * - Tri stable par (date ASC, id ASC)
 * @param {Array} existing - Données existantes en cache
 * @param {Array} incoming - Nouvelles données arrivées
 * @returns {Array} Données fusionnées, dédupliquées et triées
 */
export function mergeAttendance(existing = [], incoming = []) {
  const map = new Map();
  
  // D'abord, ajouter toutes les lignes existantes
  for (const row of existing) {
    map.set(row.id, row);
  }
  
  // Puis fusionner avec les nouvelles (écrase les champs)
  for (const row of incoming) {
    const prev = map.get(row.id) || {};
    map.set(row.id, { ...prev, ...row });
  }
  
  // Convertir en array et trier
  const arr = Array.from(map.values());
  arr.sort((a, b) => {
    // Tri par date d'abord
    const da = (a.date || '').localeCompare(b.date || '');
    if (da !== 0) return da;
    // Puis par id pour stabilité
    return ((a.id || 0) - (b.id || 0));
  });
  
  return arr;
}

